var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M.934 2.874c0-.48.389-.87.87-.87h9.39a.87.87 0 0 1 0 1.74h-9.39a.87.87 0 0 1-.87-.87",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.442 1.565a.26.26 0 0 0-.26.261V2.87a.783.783 0 0 1-1.566 0V1.826A1.826 1.826 0 0 1 5.442 0H7.53a1.826 1.826 0 0 1 1.826 1.826V2.87a.783.783 0 0 1-1.565 0V1.826a.26.26 0 0 0-.261-.26zm-2.609.522c.433 0 .783.35.783.783v7.304a.26.26 0 0 0 .26.26h5.218a.26.26 0 0 0 .261-.26V2.87a.783.783 0 1 1 1.565 0v7.304A1.826 1.826 0 0 1 9.094 12H3.877a1.826 1.826 0 0 1-1.826-1.826V2.87c0-.433.35-.783.782-.783",
  clipRule: "evenodd"
})));
export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.f6f94b0e.svg";